import { Typography } from '@mui/material';
import { AutoCompleteInput } from 'Components/HookFormInputs/AutoCompleteInput';
import { CheckboxInput } from 'Components/HookFormInputs/CheckboxInput';
import { TextInput } from 'Components/HookFormInputs/TextInput';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDictionary } from 'Hooks';
import { IUpdateBankDetails } from 'Interfaces/updateBankDetails';
import { sanitizeNumbers } from 'Utils/sanitizeNumbers';
import { useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

export const Form = () => {
  const {
    register,
    formState: { errors },
    watch,
    resetField,
  } = useFormContext<IUpdateBankDetails>();

  const generalOptions = useAppSelector(
    (generalOptions) => generalOptions.generalOptions.generalOptions
  );

  const dictionary = useDictionary(Dictionary, DICTIONARY.UpdateBankDetails);

  const isReset = useRef<boolean>(false);

  useEffect(() => {
    resetField('branchId', { defaultValue: undefined });
    isReset.current = true;
  }, [watch('bankId')]);

  return (
    <>
      <Typography variant={'body1'}>{dictionary.bankDetails}</Typography>
      <AutoCompleteInput
        name='bankId'
        label={dictionary.inputLabel1}
        options={
          generalOptions?.banks?.map((bank) => ({
            id: bank.id,
            value: `${bank.code} - ${bank.value}`,
          })) || []
        }
      />
      <AutoCompleteInput
        name='branchId'
        label={dictionary.inputLabel2}
        options={
          generalOptions?.banks
            ?.find((bank) => bank.id === watch('bankId'))
            ?.branches?.map((branch) => ({
              id: branch.id,
              value: `${branch.branchIdNumber} - ${branch.value}`,
            })) || []
        }
        isReset={isReset}
      />
      <TextInput
        register={register('accountNum', {
          onChange: sanitizeNumbers,
        })}
        errors={(errors as any)?.accountNum}
        label={dictionary.inputLabel3}
        shrink={(watch('accountNum') || '')?.length > 0}
        isNumbersOnly={true}
      />
      <CheckboxInput
        label={dictionary.inputLabel4}
        name='isOwner'
        register={register('isOwner')}
        error={(errors as any)?.isOwner}
      />
    </>
  );
};
